// GrowthOS skeleton placeholder for AG Grid loading states.
// Overlays the grid (shimmer rows) instead of a spinner. Purely presentational.
const COL_WIDTHS = ['70%', '55%', '80%', '60%', '50%', '72%'];

const GridSkeleton = ({ rows = 10, cols = 5 }) => (
  <div className="gos-skel" aria-hidden="true">
    {Array.from({ length: rows }).map((_, r) => (
      <div className="gos-skel-row" key={r}>
        <span className="gos-skel-box gos-skel-an" />
        <div className="gos-skel-lead">
          <span className="gos-skel-avatar gos-skel-an" />
          <div className="gos-skel-lines">
            <span className="gos-skel-bar gos-skel-an" style={{ width: '62%' }} />
            <span className="gos-skel-bar gos-skel-an sm" style={{ width: '44%' }} />
          </div>
        </div>
        {Array.from({ length: cols }).map((_, c) => (
          <div className="gos-skel-col" key={c}>
            <span className="gos-skel-bar gos-skel-an" style={{ width: COL_WIDTHS[c % COL_WIDTHS.length] }} />
          </div>
        ))}
      </div>
    ))}
  </div>
);

export default GridSkeleton;
